export default "__VITE_ASSET__9a4a174a__"